import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import SpecialKeysReact from 'special-keys-react'
import ArrowKeysReact from 'arrow-keys-react'

import { t } from 'translation'
import history from 'utils/appHistory'
import { updateSession } from 'utils/sqlite'

import Aside from 'components/Aside/Aside'
import AsideControls from 'components/Aside/AsideControls'
import Logo from 'components/Logo/Logo'
import Player from 'components/Player/Player'
import PlayerTopButtons from 'components/Player/PlayerTopButtons'
import SettingsModal from 'components/SettingsModal/SettingsModal'
import Spinner from 'components/ui/Spinner/Spinner'

import {
  endAlarmLaunch,
  setPlayState,
  setImmersiveVideo,
  setSongInfo,
  fetchAllMusic,
  startPlaylist,
  playPlaylistNext,
  endPlaylistPlay,
  setPlayedTime,
} from 'store/actions'

import { AWAKENING, SLEEP } from 'utils/constants'
import { getImmersiveVideoUrl } from 'utils/http'
import { sessionApi } from 'api/session'

const immersiveData = [
  {
    file: `Antartique`,
    vidExt: `mp4`,
    thumbExt: `jpeg`,
    title: `${t('video.ANTARCTIC')}`,
  },
  {
    file: `Botswana`,
    vidExt: `mp4`,
    thumbExt: `jpeg`,
    title: `${t('video.BOTSWANA')}`,
  },
  {
    file: `Brasil`,
    vidExt: `mp4`,
    thumbExt: `jpeg`,
    title: `${t('video.BRASIL')}`,
  },
  {
    file: `Caraibes`,
    vidExt: `mp4`,
    thumbExt: `jpeg`,
    title: `${t('video.CARAIBES')}`,
  },
  {
    file: `Desert-Du-Maroc`,
    vidExt: `mp4`,
    thumbExt: `jpeg`,
    title: `${t('video.DESERT-DU-MAROC')}`,
  },
  {
    file: `Indonesie`,
    vidExt: `mp4`,
    thumbExt: `jpeg`,
    title: `${t('video.INDONESIE')}`,
  },
  {
    file: `Mali`,
    vidExt: `mp4`,
    thumbExt: `jpeg`,
    title: `${t('video.MALI')}`,
  },
  {
    file: `Med-Celtique`,
    vidExt: `mp4`,
    thumbExt: `jpeg`,
    title: `${t('video.MED-CELTIQUE')}`,
  },
  {
    file: `Mongole`,
    vidExt: `mp4`,
    thumbExt: `jpeg`,
    title: `${t('video.MONGOLE')}`,
  },
]

class PlayerPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      asideType: '',
      lastAsideType: '',
      asidesContent: {
        immersive: immersiveData,
        description: [],
      },
      finished: false,
      areSettingsOpen: false,
      isLoadingTrackInfo: false,
      playAtLeastSixtySec: false,
      disableSlider: false,
      currentImmersive: 0,
    }

    SpecialKeysReact.config({
      left: () => {
        if (this.state.disableSlider && this.state.asideType !== 'immersive')
          this.backButton.click()

        if (this.state.asideType === 'immersive' && !this.props.immersiveVideo) {
          this.closeAsideHandler()
          this.setState({ currentImmersive: 0 })
          this.mainElement.current.focus()
        }

        if (this.props.immersiveVideo) this.closeImmersiveButton.click()
      },
      right: () => {
        if (this.state.asideType !== 'immersive') {
          if (this.state.disableSlider) {
            if (this.state.asideType !== '') {
              this.closeAsideHandler()
              if (this.state.lastAsideType === 'immersive')
                this.setState({ currentImmersive: 0 })
              this.mainElement.current.focus()
              return
            }

            if (
              this.state.lastAsideType === '' ||
              this.state.lastAsideType === 'immersive'
            ) {
              this.openAsideHandler('description')
              this.setState({ lastAsideType: 'description' })
              return
            }

            if (this.state.lastAsideType === 'description') {
              this.openAsideHandler('immersive')
              this.setState({ lastAsideType: 'immersive' })
              return
            }
          }
        }
      },
      up: () => {
        if (this.state.asideType === 'immersive' && this.props.immersiveVideo === null) {
          this.immersiveRef.current[
            this.state.currentImmersive - 1 < 0
              ? this.immersiveRef.current.length - 1
              : this.state.currentImmersive - 1
          ].focus()
          this.setState({
            currentImmersive:
              this.state.currentImmersive - 1 < 0
                ? this.immersiveRef.current.length - 1
                : this.state.currentImmersive - 1,
          })
        }
      },
      down: () => {
        if (this.state.asideType !== 'immersive' && this.state.disableSlider) {
          this.settingsButton.click()
          this.mainElement.current.focus()
        }

        if (this.state.asideType === 'immersive' && this.props.immersiveVideo === null) {
          this.immersiveRef.current[
            this.state.currentImmersive + 1 > this.immersiveRef.current.length - 1
              ? 0
              : this.state.currentImmersive + 1
          ].focus()
          this.setState({
            currentImmersive:
              this.state.currentImmersive + 1 > this.immersiveRef.current.length - 1
                ? 0
                : this.state.currentImmersive + 1,
          })
        }
      },
      backspace: () => {},
      enter: () => {
        if (this.state.asideType === 'immersive') {
          this.immersiveRef.current[this.state.currentImmersive].click()
          return
        }

        if (!this.state.disableSlider) this.setState({ disableSlider: true })

        if (this.props.immersiveVideo === null && this.state.disableSlider)
          this.playPauseButton.click()

        this.mainElement.current.focus()
      },
    })

    this.mainElement = React.createRef()
  }

  backButton = null
  settingsButton = null
  playPauseButton = null
  immersiveRef = null
  closeImmersiveButton = null

  attachBackBtnRef = (btn) => (this.backButton = btn)

  attachSettingsBtnRef = (btn) => (this.settingsButton = btn)

  attachPlayPauseBtnRef = (btn) => (this.playPauseButton = btn)

  attachImmersiveRef = (data) => (this.immersiveRef = data)

  attachCloseImmersiveBtnRef = (btn) => (this.closeImmersiveButton = btn)

  setCurrentImmersiveRef = (index) => this.setState({ currentImmersive: index })

  openAsideHandler = (asideToOpen) => {
    // If no content, don't open aside
    if (!this.state.asidesContent[asideToOpen].length) return

    // If already open and clicking same kind, simply close
    if (this.state.asideType === asideToOpen) return this.closeAsideHandler()

    // If aside is open with content of another kind, first close it
    if (this.state.asideType) {
      this.closeAsideHandler()
      // ...and then open after closing animation is complete
      setTimeout(() => {
        this.setState({
          asideType: asideToOpen,
        })
      }, 300)
    } else {
      // If aside is closed and there is content of this kind, open it
      this.setState({
        asideType: asideToOpen,
      })
    }
  }

  openImmersiveVideoHandler = (fileName) => {
    if (!this.props.canPlayImmersive) return
    const videoUrl = getImmersiveVideoUrl(fileName)
    this.props.setImmersiveVideo(videoUrl)
  }

  closeImmersiveVideoHandler = (e) => {
    if (e) e.stopPropagation()
    this.props.setImmersiveVideo(null)
  }

  onFinishSessionHandler = (playTime) => {
    this.setState({ finished: true }, async () => {
      const isPlayingFromPlaylist = typeof this.props.playingPlaylistSong === 'number'

      // If in playlist mode, will not give rating after, so send session end api call here
      const shouldSendSessionUpdate = isPlayingFromPlaylist

      if (shouldSendSessionUpdate && this.props.sessionId) {
        const data = {
          playTime,
          id: this.props.sessionId,
          endEvent: 'songEnd',
          sessionEnd: new Date(),
        }

        if (!window?.cordova || this.props.sessionOnline) {
          sessionApi
            .sendSessionInfoAfter(data)
            .then(({ result, error }) =>
              console.log('Update session result: ', error || result)
            )
        } else {
          await updateSession(this.props.sessionDb, this.props.sessionDbTable, data)
        }
      }

      const playlistTracksLeftToPlay =
        this.props.playingPlaylistSong < this.props.playlist.length - 1

      if (!isPlayingFromPlaylist) return

      if (playlistTracksLeftToPlay) this.props.playPlaylistNext()
      else this.props.endPlaylistPlay()
    })
  }

  closeAsideHandler = () => {
    this.setState({
      asideType: '',
    })
  }

  clickOutsideOfAsideHandler = ({ target }) => {
    // Don't close the aside if closing immersive video
    if (this.props.immersiveVideo) return

    const asides = document.querySelectorAll('div.aside_menu_wrap')
    const asideButtons = document.querySelectorAll('button.player_bottom_btn')
    // If an aside is not open, no need to proceed
    if (!this.state.asideType) return

    const clickOutsideOfAside = [...asides].every((aside) => !aside.contains(target))
    const clickNotOnAnAsideOpenButton = [...asideButtons].every(
      (button) => !button.contains(target)
    )

    if (clickOutsideOfAside && clickNotOnAnAsideOpenButton) this.closeAsideHandler()
  }

  setSixtySecondsPlayedHandler = () =>
    !this.state.playAtLeastSixtySec && this.setState({ playAtLeastSixtySec: true })

  toggleSettingsHandler = () => {
    this.setState((prevState) => ({
      areSettingsOpen: !prevState.areSettingsOpen,
    }))
  }

  loadSongInfo = async () => {
    this.setState({ isLoadingTrackInfo: true, playAtLeastSixtySec: false })
    if (
      !window?.cordova &&
      (!Object.keys(this.props.allGenresMap).length || !this.props.allSongs.length)
    )
      await this.props.fetchAllMusic()

    if (
      window?.cordova &&
      !this.props.isFetchingSongsFromRemote &&
      (!Object.keys(this.props.allGenresMap).length || !this.props.allSongs.length)
    )
      await this.props.fetchAllMusic()

    const selectedSongId = this.props.songId

    // Proceed with loading song only if indicationType and songId are set, and if pain before rating is set
    // unless launching alarm, since otherwise page will automatically redirect
    const idAndSessionIsSet = this.props.indicationType && selectedSongId
    const isPlayingFromPlaylist = typeof this.props.playingPlaylistSong === 'number'
    const painBeforeInfoIsSet = this.props.painLevelBefore !== null

    if (
      idAndSessionIsSet &&
      (painBeforeInfoIsSet ||
        this.props.indicationType === SLEEP ||
        this.props.indicationType === AWAKENING ||
        this.props.isLaunchingAlarm ||
        isPlayingFromPlaylist)
    ) {
      // Find info for requested song
      const songInfo = !this.props.isFetchingSongsFromRemote
        ? this.props.allSongsMap[selectedSongId]
        : this.props.allLocalSongsMap[selectedSongId]

      if (!songInfo) return console.error('Missing song info')
      const { description, instruments } = songInfo

      // Prevent a 'Can't perform a React state update on an unmounted component.'
      if (!this.isUnmounting) {
        this.props.setSongInfo(songInfo)
        this.setState((prevState) => ({
          asidesContent: {
            ...prevState.asidesContent,
            description: [{ description, instruments }],
          },
          finished: false,
          isLoadingTrackInfo: false,
        }))
      }
    }
  }

  componentDidMount() {
    this.loadSongInfo()

    // Add event listener for closing aside when click outside of aside, but not on aside buttons
    document.body.addEventListener('click', this.clickOutsideOfAsideHandler)
    //this.mainElement.current.focus()
    this.mainElement.current.focus()
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.songId !== this.props.songId ||
      // In case first song in playlist is same as current song
      (this.props.playingPlaylistSong === 0 &&
        this.props.playingPlaylistSong !== prevProps.playingPlaylistSong)
    )
      this.loadSongInfo()

    if (prevProps.immersiveVideo !== null && this.props.immersiveVideo === null)
      this.immersiveRef.current[this.state.currentImmersive].focus()

    if (prevState.areSettingsOpen && !this.state.areSettingsOpen)
      this.mainElement.current.focus()
  }

  componentWillUnmount() {
    this.isUnmounting = true

    // Remoe event listener for closing aside when click outside of aside, but not on aside buttons
    document.body.removeEventListener('click', this.clickOutsideOfAsideHandler)

    // Remove immersive video
    if (this.props.immersiveVideo) this.props.setImmersiveVideo(null)

    // If loaded player via alarm, remove launching alarm status
    if (this.props.isLaunchingAlarm) this.props.endAlarmLaunch()

    if (this.props.playState) this.props.setPlayState(false)

    const isPlayingFromPlaylist = typeof this.props.playingPlaylistSong === 'number'
    // In case in playlist mode and navigate away without playlist ending by itself
    if (isPlayingFromPlaylist) this.props.endPlaylistPlay()
  }

  render() {
    const beforePainIsSet = this.props.painLevelBefore !== null
    const isPlayingFromPlaylist = typeof this.props.playingPlaylistSong === 'number'

    let redirect = null
    // If treatment mode missing, redirect to treatment mode selection
    if (!this.props.indicationType) redirect = <Redirect to="/indication-select" />
    // If song id missing, redirect to song selection
    else if (!this.props.songId) redirect = <Redirect to="/song-select" />
    // If pain before rating not present, not launching via alarm or playlist,
    // and did not just finish playlist, redirect to pain rating
    // else if (
    //   !beforePainIsSet &&
    //   this.props.indicationType !== SLEEP &&
    //   this.props.indicationType !== AWAKENING &&
    //   !this.state.finished &&
    //   !this.props.isLaunchingAlarm &&
    //   !isPlayingFromPlaylist
    // )
    //   redirect = <Redirect to="/pain-rating" />
    else if (this.state.finished) {
      // If did NOT launch player via alarm or playlist,
      // pain level and sessionid for this listening session is already set,
      // so redirect to pain after rating
      // if (
      //   beforePainIsSet ||
      //   this.props.indicationType === SLEEP ||
      //   this.props.indicationType === AWAKENING
      // ) {
      //   const to = { pathname: '/pain-rating' }

      //   redirect = <Redirect to={to} />
      // }
      // If finished via alarm or NOT launching another playlist track,
      // go back to session type selection
      if (!isPlayingFromPlaylist) {
        const redirectPath = this.props.isDoctor
          ? `/welcome-doctor`
          : '/indication-select'

        redirect = <Redirect to={redirectPath} />
      }
    }

    return (
      <Fragment>
        {/* If missing info, redirect */}
        {/* Checking pathname prevents 'attempt to redirect to path you are on' error in console */}
        {history.location.pathname !==
          (redirect?.props.to?.pathname || redirect?.props.to) && redirect}
        {/* Otherwise, render player */}
        <div ref={this.mainElement} {...SpecialKeysReact.events} tabIndex="3">
          <section className="section offset_v2_mod offset_top_mob_mod scroll_mod">
            <PlayerTopButtons
              toggleSettingsHandler={this.toggleSettingsHandler}
              isPlayingFromPlaylist={isPlayingFromPlaylist}
              attachBackBtnRef={this.attachBackBtnRef}
              attachSettingsBtnRef={this.attachSettingsBtnRef}
            />
            {this.props.songInfo &&
            !this.state.finished &&
            !this.state.isLoadingTrackInfo ? (
              <Player
                attachPlayPauseBtnKeyRef={this.attachPlayPauseBtnRef}
                onFinishSessionHandler={this.onFinishSessionHandler}
                closeImmersiveVideoHandler={this.closeImmersiveVideoHandler}
                setSixtySecondsPlayedHandler={this.setSixtySecondsPlayedHandler}
                setElapsedPlayTime={(newTotalPlayTime) =>
                  this.props.setPlayedTime(newTotalPlayTime)
                }
                disableByKey={this.state.disableSlider}
                attachCloseImmersiveBtnRef={this.attachCloseImmersiveBtnRef}
                asidesContent={this.state.asidesContent}
              />
            ) : (
              <Spinner />
            )}
            <div className="player_bottom_wrap">
              <div
                className={`player_bottom v2_mod left_side_mod ${
                  this.props.hasCompanyLogo ? 'left_side_mod' : ''
                }`}
              >
                <AsideControls
                  asidesContent={this.state.asidesContent}
                  openAsideType={this.state.asideType}
                  openAsideHandler={this.openAsideHandler}
                  canPlayImmersive={this.props.canPlayImmersive}
                />
                <Logo modClass="bar_mod" />
              </div>
            </div>
          </section>
          <Aside
            closeAside={this.closeAsideHandler}
            kind={this.state.asideType === 'description' ? 'description' : ''}
            content={this.state.asidesContent[this.state.asideType]}
            side={'left'}
          />
          <Aside
            attachImmersiveRef={this.attachImmersiveRef}
            closeAside={this.closeAsideHandler}
            kind={this.state.asideType !== 'description' ? this.state.asideType : ''}
            content={this.state.asidesContent[this.state.asideType]}
            openImmersiveVideoHandler={this.openImmersiveVideoHandler}
            setCurrentImmersiveRef={this.setCurrentImmersiveRef}
            side={'right'}
          />
          <SettingsModal
            toggleSettingsHandler={this.toggleSettingsHandler}
            areSettingsOpen={this.state.areSettingsOpen}
          />
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = ({
  auth: { isPro, attributes, isDoctor, isOnline },
  player: {
    allGenresMap,
    allSongs,
    allSongsMap,
    allLocalSongs,
    allLocalSongsMap,
    allLocalGenresMap,
    isFetchingSongsFromRemote,
    immersiveVideo,
    songId,
    songInfo,
    indicationType,
    painLevelAfter,
    painLevelBefore,
    playState,
    sessionId,
    playingPlaylistSong,
    playlist,
    sessionDb,
    sessionDbTable,
    sessionOnline,
  },
  alarm: { isLaunchingAlarm },
}) => ({
  allGenresMap,
  allSongs,
  allSongsMap,
  allLocalSongs,
  allLocalSongsMap,
  allLocalGenresMap,
  isFetchingSongsFromRemote,
  hasCompanyLogo: attributes?.companyLogo,
  isPro,
  isOnline,
  isLaunchingAlarm,
  immersiveVideo,
  indicationType,
  painLevelAfter,
  painLevelBefore,
  playState,
  sessionId,
  songId,
  songInfo,
  playingPlaylistSong,
  playlist,
  isDoctor,
  sessionDb,
  sessionDbTable,
  sessionOnline,
  canPlayImmersive: attributes?.permissions?.features?.immersive,
})

const willMapDispatchToProps = {
  setPlayedTime,
  endAlarmLaunch,
  setPlayState,
  setImmersiveVideo,
  setSongInfo,
  fetchAllMusic,
  startPlaylist,
  playPlaylistNext,
  endPlaylistPlay,
}

export default connect(mapStateToProps, willMapDispatchToProps)(PlayerPage)
